// Generate Chicago, APA, and MLA citation strings for a Receipts entry and for its individual citations.
// Format choices follow the most common student/researcher conventions for government & news sources.

const SITE_NAME = "Receipts — Women's Rights Accountability Tracker";
const SITE_PUBLISHER = "Receipts";

const monthLong = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const monthAbbr = [
  "Jan.", "Feb.", "Mar.", "Apr.", "May", "June",
  "July", "Aug.", "Sept.", "Oct.", "Nov.", "Dec.",
];

const parseDate = (iso) => {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return null;
  return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]) };
};

const cleanTitle = (t) => (t || "").replace(/\s+/g, " ").trim();

// ---- Entry-level citations (the Receipts page itself) ----

export const formatEntryChicago = (entry, pageUrl) => {
  const dt = parseDate(entry.date_action);
  const accessed = new Date();
  const accessedStr = `${monthLong[accessed.getMonth()]} ${accessed.getDate()}, ${accessed.getFullYear()}`;
  const dateStr = dt ? `${monthLong[dt.mo - 1]} ${dt.d}, ${dt.y}` : "n.d.";
  return `"${cleanTitle(entry.title)}." ${SITE_NAME}, ${dateStr}. Accessed ${accessedStr}. ${pageUrl}.`;
};

export const formatEntryAPA = (entry, pageUrl) => {
  const dt = parseDate(entry.date_action);
  const dateStr = dt ? `(${dt.y}, ${monthLong[dt.mo - 1]} ${dt.d})` : "(n.d.)";
  return `${SITE_PUBLISHER}. ${dateStr}. ${cleanTitle(entry.title)}. ${SITE_NAME}. ${pageUrl}`;
};

export const formatEntryMLA = (entry, pageUrl) => {
  const dt = parseDate(entry.date_action);
  const dateStr = dt ? `${dt.d} ${monthAbbr[dt.mo - 1]} ${dt.y}` : "n.d.";
  const accessed = new Date();
  const accessedStr = `${accessed.getDate()} ${monthAbbr[accessed.getMonth()]} ${accessed.getFullYear()}`;
  return `"${cleanTitle(entry.title)}." ${SITE_NAME}, ${dateStr}, ${pageUrl}. Accessed ${accessedStr}.`;
};

// ---- BibTeX export for academic use ----

export const formatEntryBibTeX = (entry, pageUrl) => {
  const dt = parseDate(entry.date_action);
  const key = `receipts_${(entry.id || "entry").slice(0, 8)}`;
  return `@misc{${key},
  title  = {${cleanTitle(entry.title)}},
  author = {{${SITE_PUBLISHER}}},
  year   = {${dt ? dt.y : "n.d."}},
  month  = {${dt ? monthLong[dt.mo - 1].toLowerCase() : ""}},
  howpublished = {\\url{${pageUrl}}},
  note   = {${SITE_NAME}; accessed ${new Date().toISOString().slice(0, 10)}}
}`;
};

export const CITATION_STYLES = [
  { key: "chicago", label: "Chicago", format: formatEntryChicago },
  { key: "apa", label: "APA", format: formatEntryAPA },
  { key: "mla", label: "MLA", format: formatEntryMLA },
  { key: "bibtex", label: "BibTeX", format: formatEntryBibTeX },
];
